import {Component, Input, forwardRef, Output, EventEmitter} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {FormBuilder, IMsfFormBuilder} from "@components/form-builder/form-builder";
import {Button, ButtonDirective} from "primeng/button";
import {TranslatePipe} from "@ngx-translate/core";
import {NgClass} from "@angular/common";
import {ClearButton} from '@components/button/clear-button/clear-button';
import {Loading} from '@components/ui/loading/loading';
import {ExportButton} from '@components/button/export-button/export-button';
import {SecondaryButton} from '@components/button/secondary-button/secondary-button';

@Component({
    selector: 'msf-filters',
    templateUrl: './filters.html',
    styleUrl: './filters.scss',
    standalone: true,
  imports: [
    FormBuilder,
    Button,
    TranslatePipe,
    ButtonDirective,
    NgClass,
    ClearButton,
    Loading,
    ExportButton,
    SecondaryButton
  ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => Filters),
            multi: true
        }
    ]
})
export class Filters implements ControlValueAccessor {
    @Input() method!: string;
    @Input({required:true}) fields: IMsfFormBuilder[] = [];
    @Input() save: boolean = false;
    @Input() export: boolean = false;
    @Input()  import  = false;
    boolean = false;
    @Input() show: boolean = false;
    @Input() isMobile: boolean = false;

    @Input() background: boolean = true;
    @Input() padding: boolean = true;
    @Input() showFilterIcon: boolean = false;
    @Input() isLoading: boolean = false;
    @Input() metaData: any = {};

    @Output() applyFilter = new EventEmitter<void>();
    @Output() clearFilter = new EventEmitter<void>();
    @Output() savedFilter = new EventEmitter<void>();
    @Output() showAllDataFilter = new EventEmitter<boolean>();
    @Output() modelChange = new EventEmitter<any>();
    @Output() exportChange = new EventEmitter<boolean>();
    @Output() onImport = new EventEmitter<boolean>();

    model: any = {};


    private onChangeCallback: (_: any) => void = () => {
    };
    private onTouchedCallback: () => void = () => {
    };


    writeValue(value: any): void {
        this.model = value || {};
    }

    registerOnChange(fn: any): void {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouchedCallback = fn;
    }

    setDisabledState(isDisabled: boolean): void {
    }

    applyFilters(): void {
        this.applyFilter.emit()
    }

    stopLoading(): void {
      this.isLoading = false;
    }

    saveFilter(): void {
        this.savedFilter.emit()
    }

  showAllData(): void {
        this.showAllDataFilter.emit()
    }
    clearFilters(): void {
        this.model = {};
        this.clearFilter.emit()
    }

    toggleFilters(): void {
    }

}
